export default __webpack_public_path__ + "assets/images/594b05ffad9e4e11c9ea2927646bfe00.png";